export default {"src":"/_next/static/media/PT.d1681afe.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};